module.exports = __webpack_public_path__ + "static/PeepShowMainMenu-2dc7dbcb8309671a024f1015aac9ca8e.mp4";